import { axios, isUndNullEmp, getResponse, settings } from '../../helpers/main';
import { Configuration } from '../../classess/configuration/configuration';
import { userAuthContextType } from '../../auth/AuthProvider';

const authService = { user: userAuthContextType };
const objectService = getResponse({ type: 0 }); // eslint-disable-line

export class ConfigurationService {
    /**
     * @param {Object} params
     * @param {authService} params.auth
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns {Promise<objectService>}
     */
    static async getAll({
        auth = authService,
        languageId = '',
        subMethod = '',
    } = {}) {
        const currentMethod = 'ConfigurationService.getAll';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.configurations}/`,
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    method: settings?.backend?.methods?.configurations?.getAll,
                    languageId: languageId,
                },
                subMethod: currentMethod,
            };

            response = await axios?.post(requestObj);

            if (response?.isSuccess && !response?.isWarning) {
                const configurationsData = response?.result?.configurations || [];
                response.result = configurationsData.map(c => Configuration.getClass(c, false));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {Object} params
     * @param {authService} params.auth
     * @param {string} params.id
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns {Promise<objectService>}
     */
    static async getById({
        auth = authService,
        id = '',
        languageId = '',
        subMethod = '',
    } = {}) {
        const currentMethod = 'ConfigurationService.getById';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.configurations}/`,
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    id: id,
                    languageId: languageId,
                    method: settings?.backend?.methods?.configurations?.getById,
                },
                subMethod: currentMethod,
            };

            response = await axios?.post(requestObj);

            if (response?.isSuccess && !response?.isWarning) {
                const configurationData = response?.result?.configuration || {};
                response.result = Configuration.getClass(configurationData, false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {Object} params
     * @param {authService} params.auth
     * @param {string} params.id
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns {Promise<objectService>}
     */
    static async deleteAsync({
        auth = authService,
        id = '',
        languageId = '',
        subMethod = '',
    } = {}) {
        const currentMethod = 'ConfigurationService.deleteAsync';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.configurations}/${id}`,
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    languageId: languageId,
                },
                subMethod: currentMethod,
            };

            response = await axios?.delete(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {Object} params
     * @param {authService} params.auth
     * @param {Object} params.data
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns {Promise<objectService>}
     */
    static async create({
        auth = authService,
        data = {},
        languageId = '',
        subMethod = '',
    } = {}) {
        const currentMethod = 'ConfigurationService.create';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.configurations}/`,
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    data: data,
                    languageId: languageId,
                },
                subMethod: currentMethod,
            };

            response = await axios?.post(requestObj);

            // if (response?.isSuccess && !response?.isWarning) {
            //     const configurationData = response?.result?.configuration || {};
            //     response.result = Configuration.class(configurationData, false);
            // }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    /**
     * @param {Object} params
     * @param {authService} params.auth
     * @param {string} params.id
     * @param {Object} params.data
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns {Promise<objectService>}
     */
    static async update({
        auth = authService,
        id = '',
        data = {},
        languageId = '',
        subMethod = '',
    } = {}) {
        const currentMethod = 'ConfigurationService.update';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.configurations}/${id}`,
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    data: data,
                    languageId: languageId,
                },
                subMethod: currentMethod,
            };

            response = await axios?.post(requestObj);

            // if (response?.isSuccess && !response?.isWarning) {
            //     const configurationData = response?.result?.configuration || {};
            //     response.result = Configuration.class(configurationData, false);
            // }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
}
